'use client';
import React from 'react';
import styled from '@benzinga/themetron';
import CarouselBlock, { CarouselData, ItemProps } from './CarouselBlock';
import { SessionContext } from '@benzinga/session-context';
import { EventsManager } from '@benzinga/events-manager';

export interface CarouselEventsProps {
  attrs: {
    data: { initialItems?: ItemProps[] } & CarouselData;
  };
}

export const CarouselEventsBlock: React.FC<CarouselEventsProps> = ({ attrs }) => {
  const session = React.useContext(SessionContext);
  const eventsManager = session.getManager(EventsManager);
  const [items, setItems] = React.useState<ItemProps[]>(attrs?.data?.initialItems ?? []);

  React.useEffect(() => {
    if (!items.length) {
      eventsManager.getEvents().then(res => {
        if (Array.isArray(res?.ok)) {
          const formattedItems = res.ok.map(item => ({
            href: item.acf.learn_more,
            id: item.id,
            image: item.acf.marketing_image ?? '',
            subtitle: item.acf.date_and_location,
            title: item.title.rendered,
          }));
          setItems(formattedItems);
        }
      });
    }
  }, [eventsManager, items]);

  return (
    <Container>
      <CarouselBlock attrs={{ ...attrs }} items={items} />
    </Container>
  );
};

const Container = styled.div`
  margin: 1rem auto;
`;
